// extracted by mini-css-extract-plugin
export default {"cls1":"CitationModal-cls1___7b841837d528dee40d4","cls2":"CitationModal-cls2___9552ed26ac1739f172b CitationModal-cls1___7b841837d528dee40d4"};